<phx-select
[phxTriggerTemplate]="phxSelectTrigger"
[phxAllowClear]="false"
[disabled]="phxDisabled"
[(ngModel)]="phxSelected"
(ngModelChange)="phxSelectedChange.emit($event)"
phxDropdownWidth="auto"
>
  <phx-select-option
    *ngFor="let option of phxOptions"
    [label]="option.label"
    [value]="option.value"
    [data]="option.data"
    [disabled]="option.disabled"
  ></phx-select-option>
</phx-select>
<ng-template #phxSelectTrigger let-opt>
  <phx-tag [phxContrast]="opt?.data?.tagContrast || phxContrast" [phxSuffixIcon]="ChevronDownIcon" [disabled]="disabled" [phxTagType]="opt?.data?.tagType || phxTagType">
    {{opt?.label || phxPlaceholder}}
  </phx-tag>
</ng-template>